var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tui-conversation",on:{"click":_vm.handleClickConv}},[_c('ConversationNetwork'),_c('ConversationList',{on:{"handleSwitchConversation":_vm.handleSwitchConversation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }